import { render } from "./MainBox.vue?vue&type=template&id=40524b90"
import script from "./MainBox.vue?vue&type=script&lang=js"
export * from "./MainBox.vue?vue&type=script&lang=js"

import "./MainBox.vue?vue&type=style&index=0&id=40524b90&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__